export const habilidades = [
  {
    categoria: "Backend",
    itens: [
      { nome: "C#" },
      { nome: ".NET" },
      { nome: "Arquitetura em Camadas" },
      { nome: "Padrão Facade" },
      { nome: "Injeção de Dependência" },
      { nome: "Testes Unitários" },
      { nome: "Mensageria" },
    ],
  },
  {
    categoria: "Frontend",
    itens: [
      { nome: "React" },
      { nome: "JavaScript" },
      { nome: "HTML" },
      { nome: "CSS" },
    ],
  },
  {
    categoria: "Banco de Dados",
    itens: [
      { nome: "SQL" },
      { nome: "MySQL" },
      { nome: "PostgreSQL" },
      { nome: "MongoDB" },
      { nome: "Firebase Firestore" },

    ],
  },
  {
    categoria: "DevOps & Outros",
    itens: [
      { nome: "Git" },
      { nome: "Scrum" },
      { nome: "Docker" },
      { nome: "Azure" },
      { nome: "Cloudflare" },
      { nome: "Hostinger" },
    ],
  },
];
